<template>
    <div class="mt-16">
        <h2 class="mb-8">{{ __('general.holidays') }}</h2>

        <form>
            <div class="mb-4">
                <date-picker name="vacation"
                             mode="dateTime"
                             v-model="vacation"
                             :min-date="minDate"
                             :max-date="maxDate"
                             color="purple"
                             is-expanded
                             show-weeknumbers
                             is-range
                             is24hr
                             time-accuracy="2"
                >
                    <template #default="{ inputValue, inputEvents }">
                        <div class="row d-flex align-items-center">
                            <div class="col-sm-5">
                                <form-group reference-id="start" :label="__('general.range.from')"
                                >
                                    <input id="start" type="text" class="form-control" :value="inputValue.start"
                                           v-on="inputEvents.start"/>
                                </form-group>
                            </div>
                            <div class="col-sm-5">
                                <form-group reference-id="end" :label="__('general.range.till')"
                                >
                                    <input id="end" type="text" class="form-control" :value="inputValue.end"
                                           v-on="inputEvents.end"/>
                                </form-group>
                            </div>
                            <div class="col-sm-2">
                                <button class="btn btn-primary"
                                        @click.prevent="newHoliday">
                                    <i class="text-white fas fa-plus p-0"></i>
                                </button>
                            </div>
                        </div>
                    </template>
                </date-picker>
            </div>

            <div class="d-flex flex-column table-responsive-md"
                 v-if="form.vacations.length !== 0 || vacations.length !== 0">
                <table class="table">
                    <thead>
                    <tr>
                        <th scope="col">{{ __('general.range.from') }}</th>
                        <th scope="col">{{ __('general.range.till') }}</th>
                        <th scope="col">{{ __('actions.delete') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(range, index) in form.vacations" :key="index">
                        <td>{{ formatViewDate(range.start) }}</td>
                        <td>{{ formatViewDate(range.end) }}</td>
                        <td>
                            <button class="btn btn-danger"
                                    @click.prevent="removeHolidays(index)">
                            <span class="svg-icon svg-icon-md m-0"><i
                                class="text-white fas fa-trash p-0"></i></span>
                            </button>
                        </td>
                    </tr>

                    </tbody>
                </table>
            </div>

            <div class="d-flex flex-wrap">
                <button class="btn btn-primary mb-2"
                        @click.prevent="submitForm"
                        :disabled="form.vacations.length === 0 || form.processing">
                    <span class="svg-icon svg-icon-md"><i
                        class="text-white fas fa-save"></i></span>{{ __('actions.submit') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import FormGroup from '@components/Form/FormGroup.vue'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
    components: {FormGroup, DatePicker},

    props: {
        vacations: Array,
        storeUuid: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                vacations: [],
            }),

            vacation: {
                start: new Date(),
                end: new Date(),
            },
        }
    },

    methods: {
        submitForm() {
            this.form.post(this.$route('store.holidays.update', this.storeUuid), {
                preserveState: true,
                preserveScroll: true,
                only: ['vacations'],
                onSuccess: () => {
                    toastr.success(__('store.vacations_updated'))
                },
                onError: () => {
                    toastr.error(__('store.vacations_not_updated'))
                },
            })
        },
        newHoliday() {
            this.form.vacations.push({
                start: this.formatViewDate(this.vacation.start),
                end: this.formatViewDate(this.vacation.end),
            })
        },
        removeHolidays(index) {
            this.form.vacations.splice(index, 1)
        },
        formatViewDate(date) {
            let options = {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            }
            let localDate = date.toLocaleString(undefined, options)

            return localDate.replace(',', '')
        },
    },

    computed: {
        maxDate() {
            const currentDate = new Date()
            return currentDate.setFullYear(currentDate.getFullYear() + 1)
        },
        minDate() {
            return new Date()
        },
    },

    mounted() {
        for (const vacation of this.vacations) {
            this.form.vacations.push({
                start: vacation.vacation_start,
                end: vacation.vacation_end,
            })
        }
    },
}
</script>
